<template>
  <div class="">
    <v-btn
      color="primary"
      @click="copyToClipboard"
      :disabled="!isSecureConnection"
      icon
      x-small
    >
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'CopyToClipboardButton',
  props: {
    text: String
  },
  data: () => ({}),
  computed: {
    isSecureConnection: function () {
      // Clipboard bara tillgängligt vid https
      return window.isSecureContext
    }
  },
  methods: {
    copyToClipboard: function () {
      window.navigator.clipboard.writeText(this.text)
      this.$store.dispatch('snackbars/createSnackbar', {
        color: 'success',
        text: 'Text kopierad'
      })
    }
  }
}
</script>
